"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CurrentOffersGallery = /*#__PURE__*/function (_Component) {
  _inherits(CurrentOffersGallery, _Component);

  var _super = _createSuper(CurrentOffersGallery);

  function CurrentOffersGallery(props) {
    var _this;

    _classCallCheck(this, CurrentOffersGallery);

    _this = _super.call(this, props);
    _this.state = {
      images: []
    };
    _this.setupMasonryGrid = _this.setupMasonryGrid.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CurrentOffersGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupMasonry(); // Setup event listeners

      window.addEventListener("resize", this.setupMasonryGrid);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listeners
      window.removeEventListener("resize", this.setupMasonryGrid);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevProps.creads !== this.props.creads) {
        this.setupMasonry();
      }

      if (this.state.images.length !== prevState.images.length) setTimeout(function () {
        _this2.setupMasonryGrid();
      }, 100);
    }
  }, {
    key: "setupMasonry",
    value: function setupMasonry() {
      var images = [],
          _this$props = this.props,
          creads = _this$props.creads,
          setLightbox = _this$props.setLightbox;

      var _loop = function _loop(i) {
        images.push( /*#__PURE__*/_react["default"].createElement("div", {
          className: "co",
          key: i
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coWrapper"
        }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          className: "coView",
          name: "Search",
          onClick: function onClick() {
            return setLightbox(i);
          }
        }), /*#__PURE__*/_react["default"].createElement("img", {
          className: "coImage",
          alt: creads[i].title,
          src: creads[i].image
        }))));
      };

      for (var i = 0; i < creads.length; i++) {
        _loop(i);
      }

      this.setState({
        images: images
      });
    }
  }, {
    key: "setupMasonryGrid",
    value: function setupMasonryGrid() {
      for (var i = 0; i < this.props.creads.length; i++) {
        var item = document.getElementsByClassName("coImage")[i];
        var grid = document.getElementsByClassName("masonry")[0];
        var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-auto-rows"));
        var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-row-gap"));
        var rowSpan = Math.ceil((item.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
        document.getElementsByClassName("co")[i].style.gridRowEnd = "span " + (rowSpan + 30);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var images = this.state.images;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "masonry",
        style: {
          display: "grid",
          gridGap: "30px",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px,1fr))",
          gridAutoRows: "-1px",
          marginTop: "50px",
          height: '100%'
        }
      }, images);
    }
  }]);

  return CurrentOffersGallery;
}(_react.Component);

exports["default"] = CurrentOffersGallery;